export default __webpack_public_path__ + "images/4791d63358f7f6fbd2fc65545d7da994-pharmaforce-logo.svg";